<template>
  <localization :language="'sl-SI'">
    <intl :locale="'sl'">
  <div id="wrapper" :class="wrapperClass">
    <header class="header">
      <div class="adapt">
        
        <a aria-label="Na vstopno stran" href="/" rel="home" class="logo_link">
               <h1>
        
        
        
        
        
      </h1>
        </a>
        <Menu></Menu>
      </div>
    </header>
    <main id="content" class="main">
     
      <router-view></router-view>
      <!-- <div class="alert-box">
                    <div v-if="alert.message" :class="`k-notification ${alert.type}`">{{alert.message}}</div>
                  </div>

                -->

    
      <NotificationGroup
      :style="{
        
        left: '15%',
        bottom: 0,
        alignItems: 'flex-start',
        flexWrap: 'wrap-reverse',
      }"
    >
      <Fade :appear="alert.message?true:false">
        <Notification  v-if="alert.message"
          :type="{
            style: alert.n_type,
            icon: false,
          }"
          :closable="true"
          @close="onClose()"
        >
          <span>{{alert.message}}</span>
        </Notification>
      </Fade>
    </NotificationGroup>



    </main>
    <footer class="footer"></footer>
  </div>
    </intl>
</localization>
</template>

<script>
// @ is an alias to /src k-notification k-notification-success
import MenuToggleBtn from '@/components/MenuToggleBtn.vue'
import Menu from '@/components/Menu.vue'
import ContentOverlay from '@/components/ContentOverlay.vue'
import { mapState, mapActions } from 'vuex'
//import '@/assets/styles/ikc.css'


import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-vue-intl';

import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';
import numbers from 'cldr-numbers-full/main/sl/numbers.json';
import currencies from 'cldr-numbers-full/main/sl/currencies.json';
import caGregorian from 'cldr-dates-full/main/sl/ca-gregorian.json';
import dateFields from 'cldr-dates-full/main/sl/dateFields.json';
import timeZoneNames from 'cldr-dates-full/main/sl/timeZoneNames.json';

import { Fade } from '@progress/kendo-vue-animation';
import {
  Notification,
  NotificationGroup,
} from '@progress/kendo-vue-notification';

import Vue from 'vue';

Vue.prototype.$trenutnasezona=2025;

load(
    likelySubtags,
    currencyData,
    weekData,
    numbers,
    currencies,
    caGregorian,
    dateFields,
    timeZoneNames
);

import slMessages from './sl.json';
loadMessages(slMessages, 'sl-SI');


export default {

  components: {
    MenuToggleBtn,
    Menu,
    ContentOverlay,
    'localization': LocalizationProvider,
    'intl': IntlProvider,
    Fade,
    Notification,
    NotificationGroup,
  },
  created() {
   
    window.bus.$on('menu/toggle', () => {
      window.setTimeout(() => {
        this.isOpenMobileMenu = !this.isOpenMobileMenu;
      }, 200);
    });
    window.bus.$on('menu/closeMobileMenu', () => {
      this.isOpenMobileMenu = false;
    });
  },
  data() {
    return {
      isOpenMobileMenu: false,
    };
  },
  computed: {
    wrapperClass() {
      return {
        'toggled': this.isOpenMobileMenu === true,
      };
    },
    ...mapState({
            alert: state => state.alert
        })
    },
    methods: {
        ...mapActions({
            clearAlert: 'alert/clear' 
        }),
        onClose() {
          this.clearAlert();
        },
    },
    watch: {
        $route (to, from){
            // clear alert on location change
            this.clearAlert();
        }
    }
  
}

</script>


<style lang="scss">
@import 'styles/layout.scss';
//@import 'styles/ikc.scss';
@import 'styles/menu-toggle-btn.scss';
@import 'styles/menu.scss';
@import 'styles/content-overlay.scss';
@import 'styles/media-queries.scss';

.k-notification.k-notification-closable{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  width: 85vw;
;

}
.k-notification-content {
font-size: 16px;

}
.k-notification-actions {
  margin-right:20px;
}

/*#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/
</style>
